import { useMutation } from '@apollo/client'
import { ImportDialog } from '../import/import-dialog'
import {
  ImportPosProfilesDocument,
  ParsePosProfilesCsvDocument,
  PosProfileDashboardDataDocument,
  PosProfilePaymentTypesDocument,
  PosProfilesDocument,
} from '../../../generated/graphql'
import { useCallback } from 'react'
import { stripNullValues } from '../../../utils/strip-null-values'

interface Props {
  open: boolean
  onClose: () => void
}

const CSV_EXAMPLE = `
  storesettingid,name
  1,Profile #1
`

export const ImportPosProfilesDialog = (props: Props) => {
  const [parseCsvMutation, { data: parsedData, loading: parseLoading }] =
    useMutation(ParsePosProfilesCsvDocument)

  const [
    importMutation,
    { data: importData, loading: importLoading, error: importError },
  ] = useMutation(ImportPosProfilesDocument, {
    refetchQueries: [
      PosProfilesDocument,
      PosProfileDashboardDataDocument,
      PosProfilePaymentTypesDocument,
    ],
  })

  const isLoading = parseLoading || importLoading

  const onParse = useCallback(
    (csv: string) => {
      return parseCsvMutation({ variables: { csvText: csv } })
    },
    [parseCsvMutation],
  )

  const onImport = useCallback(() => {
    const parseItems = parsedData?.parsePosProfilesCSV.items.map((o) =>
      stripNullValues(o),
    )

    if (parseItems) {
      return importMutation({ variables: { data: parseItems } })
    }
  }, [importMutation, parsedData?.parsePosProfilesCSV.items])

  return (
    <ImportDialog
      {...props}
      isLoading={isLoading}
      ns="pos-profiles"
      onImport={onImport}
      onParse={onParse}
      importData={importData?.importPosProfiles}
      parsedItems={parsedData?.parsePosProfilesCSV}
      importError={importError}
      example={CSV_EXAMPLE}
    />
  )
}
